import React from "react";
import AdminNav from "./AdminNav";
import Sidebar from "./Sidebar";
import "../../Styles/DashboardLayout.css";
import DashboardRoutes from "./DashboardRoutes";
import Employeefilter from "./Employeefilter";
import {  Routes,Route } from "react-router-dom";
import Studentfilter from "./Studentfilter";
import Tpofilter from "./Tpofilter";

function DashboardLayout() {
  return (
    <div className="admin-layout">
      <AdminNav />
      <Sidebar />

      
      <Routes>
      <Route path="/Employeefilter" element={<Employeefilter/>} />
      <Route path="/Studentfilter" element={<Studentfilter/>} />
      <Route path="/Tpofilter" element={<Tpofilter/>} />

      </Routes>
    

     
      <main className="admin-main-content">
        <DashboardRoutes />

        

      </main>
    </div>
  );
}

export default DashboardLayout;
